var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/sms"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sms"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3333 13.7535H4.66665C2.66665 13.7535 1.33331 12.7535 1.33331 10.4202V5.7535C1.33331 3.42017 2.66665 2.42017 4.66665 2.42017H11.3333C13.3333 2.42017 14.6666 3.42017 14.6666 5.7535V10.4202C14.6666 12.7535 13.3333 13.7535 11.3333 13.7535Z",
    stroke: "#606060",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.3334 6.08691L9.24668 7.75358C8.56002 8.30025 7.43335 8.30025 6.74668 7.75358L4.66669 6.08691",
    stroke: "#606060",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms1);
export default __webpack_public_path__ + "static/media/sms_1.bb592c78a907f89ca979e05f7f3a3b78.svg";
export { ForwardRef as ReactComponent };